import { makeStyles } from "tss-react/mui";

export const useGroupHeaderStyle = makeStyles()(() => ({
  createHeader: {
    marginTop: 20,
  },
  detailHeader: {
    marginTop: 15,
  },
}));
